export const EVENT_SIGNAL_STATUS = Object.freeze({
  IDLE: 'idle',
  CHANGED: 'changed',
  PENDING_ACK: 'pendingAck',
  RECENTLY_ACKED: 'recentlyAcked',
})

const EVENT_SIGNAL_CHIP_DATA = Object.freeze({
  [EVENT_SIGNAL_STATUS.CHANGED]: {
    icon: 'mdi-pencil',
    labelKey: 'event.signal.changed',
    color: 'info',
    textColor: 'white',
  },
  [EVENT_SIGNAL_STATUS.PENDING_ACK]: {
    icon: 'mdi-check-circle-outline',
    labelKey: 'event.signal.pendingAck',
    color: 'warning',
    textColor: undefined,
  },
  [EVENT_SIGNAL_STATUS.RECENTLY_ACKED]: {
    icon: 'mdi-eye-check-outline',
    labelKey: 'event.signal.recentlyAcked',
    color: 'blue-grey',
    textColor: 'white',
  },
})

export function resolveEventSignalStatus(changeFlags, isOpen) {
  if (changeFlags?.isClosedPendingAck) {
    return EVENT_SIGNAL_STATUS.PENDING_ACK
  }
  if (changeFlags?.isRecentlyAcked) {
    return EVENT_SIGNAL_STATUS.RECENTLY_ACKED
  }
  if (changeFlags?.isChanged && isOpen) {
    return EVENT_SIGNAL_STATUS.CHANGED
  }
  return EVENT_SIGNAL_STATUS.IDLE
}

export function getEventSignalChipData(status) {
  return EVENT_SIGNAL_CHIP_DATA[status] || null
}
